export enum SchedulingType {
  LAUNCH_DAILY = 'LAUNCH_DAILY',

  RECURRENT = 'RECURRENT',

  PERIOD = 'PERIOD',
}
